import React from 'react';
import { translate } from 'react-i18next';

import * as NotificationHistoric from 'notifications_historic/components/form';
import * as Common from 'common/components';

const NotificationHistoricFormView = ({
  t,
  notificationHistoric,
  notification_historic,
  company,
  depreciations,
  handleAddCustomField,
  handleRemoveCustomField,
  handleSubmit,
  notifications_elementsBySections,
  allSections,
  handleAddToNotify,
  handleRemoveToNotify,
  handleCheckSection,
  handleCheckPermission,
  handleClickPermissionRow,

  handleValueChange,
  handleValidation,
  subcompany,
  isFetching,
  handleGroupChange, //Groups
  handleCustomFieldChange, //Groups
  groups, //Groups
  isSaving,
  isSubmitted,
}) => (
  <Common.Wrapper fluid={true}>
    <Common.Header title={t('notification_historic.title')} />
    <div className="col-12">
      <Common.Portlet
        title={t(
          notificationHistoric.id ? 'notification_historic.edit' : 'notification_historic.add'
        )}
        icon={'archive'}
      >
        <NotificationHistoric.Form
          notification_historic={notification_historic}
          company={company}
          depreciations={depreciations}
          handleAddCustomField={handleAddCustomField}
          handleRemoveCustomField={handleRemoveCustomField}
          handleSubmit={handleSubmit}
          notifications_elementsBySections={notifications_elementsBySections}
          allSections={allSections}
          handleAddToNotify={handleAddToNotify}
          handleRemoveToNotify={handleRemoveToNotify}
          handleCheckSection={handleCheckSection}
          handleCheckPermission={handleCheckPermission}
          handleClickPermissionRow={handleClickPermissionRow}
          handleValidation={handleValidation}
          handleValueChange={handleValueChange}
          isSubmitted={isSubmitted}
          handleGroupChange={handleGroupChange} //Groups
          handleCustomFieldChange={handleCustomFieldChange} //Groups
          groups={groups} //Groups
          isSaving={isSaving}
          subcompany={subcompany}
          values={notificationHistoric}
        />
        <Common.LoaderOverlay show={isFetching} />
      </Common.Portlet>
    </div>
  </Common.Wrapper>
);

export default translate()(NotificationHistoricFormView);



// WEBPACK FOOTER //
// src/modules/secured/modules/notifications_historic/components/NotificationHistoricFormView.js